// extracted by mini-css-extract-plugin
module.exports = {"btnSuccess":"LeftIconButton_btnSuccess__oLH69","icon":"LeftIconButton_icon__1_tGr"};